module.exports = function(store, definition) {
  for (var name in definition) {
    var property = definition[name];

    if (typeof property !== 'function' || !definition.hasOwnProperty(name)) {
      continue;
    }

    store[name] = property.bind(store);
  }

  return store;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/reflux/src/bindMethods.js
 ** module id = 235
 ** module chunks = 0
 **/